import { queryOptions } from '@tanstack/react-query';

import { BRAND_SERVICE_VERSION_HEADERS } from '@/constants/environments';
import apiClient from '@/constants/http';
import type { Cart } from '@/types/booking';
import { Logger } from '@/utils/logging';

const fetchCart = async (
  shopId?: string,
  cartId?: string,
  signal?: AbortSignal,
) => {
  try {
    if (!shopId || !cartId) return null;

    const response = await apiClient.get<Cart>(
      `/v2/shop/${shopId}/cart/${cartId}`,
      { signal, headers: BRAND_SERVICE_VERSION_HEADERS },
    );

    return response.data;
  } catch (error: unknown) {
    if (!signal?.aborted) {
      Logger.warn('Error fetching cart', { error });
    }

    return null;
  }
};

export const getCartQuery = (shopId?: string, cartId?: string) =>
  queryOptions({
    enabled: !!shopId && !!cartId,
    queryKey: ['cart', shopId, cartId],
    queryFn: ({ signal }) => fetchCart(shopId, cartId, signal),
    retry: false,
    staleTime: 30 * 60 * 1000,
    // gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
